import React, { useState, useEffect, useRef } from "react";
import Footer from "./layouts/Footer";
import Navbar from "./layouts/Navbar";
import { Link } from "react-router-dom";
import AutoNotification from "./layouts/AutoNotification";
import Section from "./layouts/Section";
import CustomAgo from "./customComponents/CustomAgo";
import { WebLink, SiteWide, Images } from "./customComponents";
import PaginatedItems from "./customComponents/PaginatedItems";

import { mainStyle, mainColor, header, otherColors } from '../utility/styles';
import Modal from 'react-modal';

import { useSelector, useDispatch } from 'react-redux';
import { tradeActions } from '../redux/actions';
import { userSelect, allRemoteSettingsSelect, homeScreenStatSelect, allTradeSelect } from '../redux/selectors/index';
import Helper1, { notify, styles, money, customNormalModalStyles, currencySliderArray } from '../utility/Helper1';
import { useSnackbar } from 'snackfy';
import Countdown from 'react-countdown';
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import ModalCustomHead from "./customComponents/ModalCustomHead";
import parse from 'html-react-parser';


import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';

import { RiMore2Fill, RiAddBoxFill, RiCloseLine, RiEye2Line, RiIndeterminateCircleFill, RiExchangeLine, RiBankFill, RiHandCoinFill, RiFundsFill, RiPieChartFill } from "react-icons/ri";

// Modern Lucide React Icons
import {
    TrendingUp,
    DollarSign,
    Activity,
    PieChart,
    Wallet,
    Clock,
    Play,
    Pause,
    RotateCcw,
    Target,
    Zap,
    Sparkles,
    BarChart3,
    Coins,
    TrendingDown
} from 'lucide-react';

const tradeBTN = require('../images/trade_button_bg.jpg');
const waveBg = require('../images/images.jpeg');

const balanceSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: false,

    responsive: [{
        breakpoint: 600,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 1
        }
    }]
};

function Arbitrage() {

    const chooseCurrency2 = useRef();
    const chooseCurrency1 = useRef();

    const site_settings = useSelector(allRemoteSettingsSelect);

    const [loading, setloading] = useState(false);
    const [tradeDataToShow, setTradeDataToShow] = useState([]);
    const [loadingText, setLoadingText] = useState('');
    const [currentSentTradeData, setCurrentSentTradeData] = useState({});
    const tradesData = useSelector(allTradeSelect);
    const finance = useSelector(homeScreenStatSelect);
    const [selectedPlan, setSelectedPlan] = useState(site_settings?.plans?.[0]?.childs?.[0]);
    const [openModal, setOpenModal] = useState(false);

    const [openTradeModal, setOpenTradeModal] = useState(false);
    const [tradeSaleData, setTradeSaleData] = useState({});

    const [tradeCapital, setTradeCapital] = useState('');
    const [selectedImage, setSelectedImage] = useState('');
    const [selectedCurrency, setSelectedCurrency] = useState('');
    const [actionOnInvestment, setActionOnInvestment] = useState(null);

    // Recommit modal state
    const [openRecommitModal, setOpenRecommitModal] = useState(false);
    const [recommitAmount, setRecommitAmount] = useState('');
    const [selectedItemForRecommit, setSelectedItemForRecommit] = useState(null);
    const [error, setError] = useState('');

    const dispatch = useDispatch();

    const arbi = require('../images/arbi.jpg');

    const type = finance?.[0]?.type
    const allUnprocessed = tradesData?.childs?.filter((item, index) => item.isProcessed == 0)
    const today = tradesData?.childs?.filter((item, index) => item.today == 1)
    const active = tradesData?.childs?.filter((item, index) => item.active == 1)
    const inActive = tradesData?.childs?.filter((item, index) => item.active == 0)
    const allUnprocessedSum = allUnprocessed?.reduce((a, b) => Number(a) + Number(b.profit), 0)

    const allProfits = today?.reduce((a, b) => Number(a) + Number(b?.profit), 0);
    const allCapitals = today?.reduce((a, b) => Number(a) + Number(b?.capital), 0);
    const allInactiveTrades = active?.reduce((a, b) => Number(a) + Number(b?.capital), 0);

    const systemPlans = site_settings.plans?.[0]?.childs;

    const dashMenu = [
        {
            icon: TrendingUp,
            name: 'Successful transaction',
            figure: (today?.length ?? 0),
            color: 'text-green-400',
            bgColor: 'bg-green-500/10',
            borderColor: 'border-green-400/30'
        },
        {
            icon: DollarSign,
            name: 'Income from transactions',
            figure: money(allProfits, type, false, { hideSymbol: true }),
            color: 'text-blue-400',
            bgColor: 'bg-blue-500/10',
            borderColor: 'border-blue-400/30'
        },
        {
            icon: PieChart,
            name: 'Total trades',
            figure: money(allCapitals + allProfits, type, false, { hideSymbol: true }),
            color: 'text-pink-400',
            bgColor: 'bg-pink-500/10',
            borderColor: 'border-pink-400/30'
        },
    ]

    if (openTradeModal) {
        // push to history when modal opens
        window.history.pushState(null, '', window.location.href)

        // close modal on 'back'
        window.onpopstate = () => {
            window.onpopstate = () => { }
            window.history.back()
            setOpenTradeModal(false)
        }
    }

    const loadAllTrade = () => {
        dispatch(tradeActions.onGETTheTrades("trade/all", response => {
        })
        )
    }



    const actionOnInvestmentFn = (item, compoundOrWithdraw) => {

        setActionOnInvestment(item.txn_id);

        dispatch(tradeActions.onPOSTTheTrades({ txnId: item.txn_id, compoundOrWithdraw }, "trade/resolve-profit-action", response => {

            setActionOnInvestment(null)
            notify(response.msg, response.code);

        }),
        )

    }

    const openRecommitModalFn = (item) => {
        setSelectedItemForRecommit(item);
        setRecommitAmount(item.capital); // Set default amount to current capital
        setOpenRecommitModal(true);
    }

    const submitRecommit = () => {
        // Clear any previous errors
        setError('');
        
        if (!selectedItemForRecommit || !recommitAmount) {
            setError('Please enter a valid amount');
            return;
        }

        if (Number(recommitAmount) < Number(selectedItemForRecommit.capital)) {
            setError('Amount cannot be less than the current capital');
            return;
        }

        setloading(true);
        setLoadingText('Processing recommit...');

        dispatch(tradeActions.onPOSTTheTrades({
            amount: recommitAmount,
            plan: selectedItemForRecommit.type,
            currency: selectedItemForRecommit.currencyId,
            recommittedFor: selectedItemForRecommit.id
        }, "trade/new", response => {
            setloading(false);
            if (response.code == 1) {
                notify(response.msg, response.code);
                setOpenRecommitModal(false);
                setRecommitAmount('');
                setSelectedItemForRecommit(null);
                setError('');
            } else {
                setError(response.msg);
            }
        }));
    }

    const closeRecommitModal = () => {
        setOpenRecommitModal(false);
        setRecommitAmount('');
        setSelectedItemForRecommit(null);
        setError('');
    }

    useEffect(() => {

        loadAllTrade();

        const reloadEverytime = setInterval(() => {
            loadAllTrade();
        }, 15000)

        return () => clearInterval(reloadEverytime);
    }, [])

    useEffect(() => {
        if (tradesData?.childs) {
            referralData()
        }
    }, [tradesData])

    const referralData = () => {
        const tradeDataLength = (tradeDataToShow?.length ?? 0);

        const tradesDataCloned = [...tradesData.childs]

        const newLength = tradesDataCloned?.slice(0, (tradeDataLength + 10));

        setTradeDataToShow((e) => [...newLength])

    }

    const customNormalModalStyles2 = {
        content: {
            top: '40%',
            left: '50%',
            right: 'auto',
            width: 400,
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            background: 'transparent',
            zIndex: 999999,
            border: 'none',

        },

        overlay: {
            position: 'fixed',
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 99999999,
            background: 'rgba(0, 0, 0, 0.8)',
            padding: 0,
            margin: 0,
            border: 'none',
        }
    };

    const plansHere = site_settings?.plans?.filter((item, index) => item.mother.type == selectedCurrency)

    function Template({ currentItems }) {
        return (
            <>
                {currentItems &&
                    currentItems.map((item) => {

                        const recommittable = site_settings?.operational_settings?.useRecommitment == 1 &&
                        item.active == 1 &&
                        item.growths == (Number(site_settings?.operational_settings?.recommitFromXGrowths) + 1) &&
                        !item.recommitterChildId;
                        const botName = systemPlans?.filter((eachPlan, eachPlanIndex) => eachPlan.type == item.type)

                        return (
                            <div key={item.txn_id} className="backdrop-blur-xl bg-white/10 rounded-3xl border border-white/20 p-6 shadow-2xl hover:shadow-3xl transition-all duration-300 mb-6">
                                <div className="flex items-start justify-between mb-6">
                                    <div className="flex items-center space-x-4">
                                        <div className="p-3 rounded-2xl bg-gradient-to-r from-blue-500/20 to-purple-500/20 border border-white/20">
                                            <Images height={40} source={botName?.[0]?.image} alt="img" />
                                        </div>
                                        <div>
                                            <h3 className="text-xl font-bold text-white mb-1">
                                                {'Trade' ?? botName?.[0]?.name}
                                            </h3>

                                            {!recommittable && <div className="flex items-center space-x-2 text-gray-300">
                                                <Clock size={16} />
                                                <Countdown
                                                    date={new Date(item?.timeToNExtMaturity)}
                                                    renderer={({ days, hours, minutes, seconds, completed }) => {
                                                        if (completed || (item.active == 0)) {
                                                            return <span className="text-sm">Matured <CustomAgo time={item?.timeToMaturedForCalculation} /></span>
                                                        } else {
                                                            return <span className="text-sm">{Number(item.currentRound)}/{item.totalRound} matures in {days}d {hours}h {minutes}m {seconds}s</span>;
                                                        }
                                                    }}
                                                />
                                            </div>}
                                        </div>
                                    </div>

                                    <div className="text-right">
                                        <p className="text-gray-300 text-sm mb-1">Investment</p>
                                        <p className="text-white text-xl font-bold">{money(item.capital, item.currencyId)}</p>
                                        {Number(item.compoundingBalance) > 0 && (
                                            <p className="text-blue-300 text-xs mt-1">
                                                +{money(item.compoundingBalance, item.currencyId)} compounded
                                            </p>
                                        )}
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div className="p-4 rounded-2xl border border-white/20 bg-white/5">
                                        <div className="flex items-center space-x-3 mb-2">
                                            <TrendingUp className="text-green-400" size={20} />
                                            <span className="text-gray-300 text-sm">Total Profit</span>
                                        </div>
                                        <p className="text-white text-2xl font-bold">
                                            {money(Number(item.profit) + Number(item.wallet), item.currencyId)}
                                        </p>
                                    </div>

                                    {Number(item.yetToCompoundBalance) > 0 && (
                                        <div className="p-4 rounded-2xl border border-white/20 bg-white/5">
                                            <div className="flex items-center space-x-3 mb-2">
                                                <Target className="text-yellow-400" size={20} />
                                                <span className="text-gray-300 text-sm">Available Balance</span>
                                            </div>
                                            <p className="text-white text-2xl font-bold mb-3">
                                                {money(item.yetToCompoundBalance, item.currencyId)}
                                            </p>
                                            <div className="flex space-x-2">
                                                <button
                                                    disabled={item.txn_id === actionOnInvestment}
                                                    onClick={() => window.confirm(`${money(item.yetToCompoundBalance, item.currencyId)} will be added to your balance for withdrawal. Are you sure you want to proceed?`) && actionOnInvestmentFn(item, 1)}
                                                    className="flex-1 py-2 px-3 rounded-xl bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white text-sm font-bold transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
                                                >
                                                    Withdraw
                                                </button>
                                                <button
                                                    disabled={item.txn_id === actionOnInvestment}
                                                    onClick={() => window.confirm(`${money(item.yetToCompoundBalance, item.currencyId)} will be compounded. Are you sure you want to proceed?`) && actionOnInvestmentFn(item, 0)}
                                                    className="flex-1 py-2 px-3 rounded-xl bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white text-sm font-bold transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
                                                >
                                                    Compound
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                    {/* Recommit Section */}
                                    {recommittable && (
                                            <div className="p-4 rounded-2xl border border-yellow-400/30 bg-yellow-500/10">
                                                <div className="flex items-center space-x-3 mb-3">
                                                    <RotateCcw className="text-yellow-400" size={20} />
                                                    <span className="text-gray-300 text-sm font-semibold">Recommitment Available</span>
                                                </div>

                                                <p className="text-yellow-200 text-sm mb-3">
                                                    This trade has reached the recommitment threshold. Click below to recommit with equal or higher amount.
                                                </p>
                                                <button
                                                    onClick={() => openRecommitModalFn(item)}
                                                    className="w-full py-2 px-4 rounded-xl bg-gradient-to-r from-yellow-500 to-orange-600 hover:from-yellow-600 hover:to-orange-700 text-white text-sm font-bold transition-all duration-300 transform hover:scale-105"
                                                >
                                                    Recommit Trade
                                                </button>
                                            </div>
                                        )}
                                </div>
                            </div>
                        );
                    })}
            </>
        );
    }

    return (
        <SiteWide title={"AI Trade Trades"}>
            <Section overlayText={loadingText} loading={loading} title={'AI Trade Trades'}>
                <div className="min-h-screen p-4">
                    <div className="max-w-7xl mx-auto pt-8">

                        {/* Modern Header */}
                        <div className="text-center mb-12">
                            <h1 className="text-5xl font-bold text-white mb-4 bg-gradient-to-r from-white via-blue-200 to-purple-200 bg-clip-text text-transparent">
                                Trade Dashboard
                            </h1>
                            <p className="text-xl text-blue-200 mb-6">
                                Monitor and manage your automated trades
                            </p>

                            {/* Quick Stats Overview */}
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
                                {dashMenu.map((item, index) => {
                                    const Icon = item.icon;
                                    return (
                                        <div key={index} className={`backdrop-blur-xl bg-white/10 rounded-2xl border ${item.borderColor} p-4 shadow-xl hover:shadow-2xl transition-all duration-300`}>
                                            <div className="flex items-center space-x-3">
                                                <div className={`p-3 rounded-xl ${item.bgColor} border ${item.borderColor}`}>
                                                    <Icon className={item.color} size={24} />
                                                </div>
                                                <div className="flex-1">
                                                    <p className="text-gray-300 text-xs mb-1">{item.name}</p>
                                                    <p className="text-white text-lg font-bold">{item.figure}</p>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        {/* Main Content Grid */}
                        <div className="grid grid-cols-1 lg:grid-cols-1 gap-8">

                            {/* Trading Bots List */}
                            <div className="lg:col-span-2 order-2 lg:order-2">
                                <div className="backdrop-blur-xl bg-white/10 rounded-3xl border border-white/20 p-6 shadow-2xl">
                                    <h2 className="text-2xl font-bold text-white mb-6 flex items-center">
                                        <Activity className="mr-3 text-purple-300" />
                                        Active Trades
                                    </h2>

                                    <div className="space-y-4">
                                        {(tradesData?.childs?.length ?? 0) > 0 ? (
                                            <PaginatedItems Template={Template} arrayOfDataToDisplay={tradesData?.childs} itemsPerPage={4} />
                                        ) : (
                                            <div className="text-center py-12">
                                                <Sparkles className="mx-auto text-gray-400 mb-4" size={48} />
                                                <h3 className="text-xl font-bold text-white mb-2">No Active Trades</h3>
                                                <p className="text-gray-400">Start your first trade to see it here</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Recommit Modal */}
                <Modal
                    isOpen={openRecommitModal}
                    onRequestClose={closeRecommitModal}
                    style={customNormalModalStyles2}
                    contentLabel="Recommit Modal"
                >
                    {selectedItemForRecommit && (
                        <div className="bg-slate-800 rounded-2xl p-8 max-w-2xl mx-auto">
                            <h2 className="text-2xl font-semibold text-white mb-6 text-center">
                                Recommit Trade
                            </h2>

                            {/* Current Trade Info */}
                            <div className="bg-slate-700/50 rounded-xl p-4 mb-6">
                                <div className="flex justify-between items-center text-white mb-2">
                                    <span className="font-semibold">Current Capital: </span>
                                    <span className="text-cyan-400 font-bold">
                                        {money(selectedItemForRecommit.capital, selectedItemForRecommit.currencyId)}
                                    </span>
                                </div>
                                <div className="flex justify-between items-center text-white mb-2">
                                    <span className="font-semibold">Current Day: </span>
                                    <span className="text-green-400 font-bold">
                                        {Number(selectedItemForRecommit.growths) - 1}
                                    </span>
                                </div>
                                <div className="text-gray-400 text-sm">
                                    New amount must be at least {money(selectedItemForRecommit.capital, selectedItemForRecommit.currencyId)}
                                </div>
                            </div>

                            {/* Amount Input */}
                            <div className="mb-6">
                                <label className="block text-white text-sm font-semibold mb-2">
                                    Recommit Amount
                                </label>
                                <div className="relative">
                                    <input
                                        type="number"
                                        value={recommitAmount}
                                        onChange={(e) => setRecommitAmount(e.target.value)}
                                        placeholder="0.00"
                                        className="w-full bg-slate-700 border border-slate-600 text-white text-xl px-4 py-4 rounded-xl focus:border-cyan-400 focus:outline-none transition-colors"
                                    />
                                </div>
                            </div>

                            {/* Validation Messages */}
                            {recommitAmount && (
                                <div className="mb-6">
                                    {Number(recommitAmount) < Number(selectedItemForRecommit.capital) && (
                                        <div className="bg-red-500/10 border border-red-500/20 text-red-400 px-4 py-3 rounded-lg">
                                            Amount cannot be less than current capital
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Error Message */}
                            {error && (
                                <div className="mb-6">
                                    <div className="bg-red-500/10 border border-red-500/20 text-red-400 px-4 py-3 rounded-lg">
                                        {error}
                                    </div>
                                </div>
                            )}

                            {/* Action Buttons */}
                            <div className="flex gap-4">
                                <button
                                    onClick={closeRecommitModal}
                                    className="flex-1 bg-slate-700 hover:bg-slate-600 text-white py-4 px-6 rounded-xl font-semibold transition-colors"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={submitRecommit}
                                    disabled={!recommitAmount || loading ||
                                        Number(recommitAmount) < Number(selectedItemForRecommit.capital)}
                                    className="flex-1 bg-gradient-to-r from-yellow-500 to-orange-600 hover:from-yellow-600 hover:to-orange-700 disabled:bg-gray-600 text-white py-4 px-6 rounded-xl font-semibold transition-all duration-300"
                                >
                                    {loading ? 'Processing...' : 'Recommit'}
                                </button>
                            </div>
                        </div>
                    )}
                </Modal>
            </Section>
        </SiteWide>
    );

}

export default Arbitrage;